import React from "react";
import { useFormContext } from "react-hook-form";

import {
  bathroomOptions,
  bedroomOptions,
  EMPTY_STRING,
} from "../../../../constants";
import { Features } from "../../../../assets";
import RoundedButton from "../../../../shared/components/buttons/RoundedButton";

const FeaturesAndAmenities = ({ handleOpenFeatureModal }) => {
  const {
    watch,
    setValue,
    formState: { errors },
    trigger,
  } = useFormContext();

  return (
    <div className="create-form-card">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <div className="form-card-heading">
          <img src={Features} alt={EMPTY_STRING} />
          Feature and Amenities
        </div>
      </div>
      <div className="rooms">
        <div className="form-card-heading">Bedrooms</div>
        <div className="options room-options">
          {bedroomOptions.map((option, index) => (
            <div
              key={index}
              className={`option room-option ${
                watch("amenity.bedrooms") === option.id
                  ? "selected-option"
                  : EMPTY_STRING
              }`}
              onClick={() => {
                setValue("amenity.bedrooms", option.id);
                trigger("amenity.bedrooms");
              }}
            >
              {option.title}
            </div>
          ))}
        </div>
        {errors?.amenity?.bedrooms && (
          <div className="error mt-2">{errors?.amenity?.bedrooms?.message}</div>
        )}
      </div>
      <div className="rooms">
        <div className="form-card-heading">Bathrooms</div>
        <div className="options room-options">
          {bathroomOptions.map((option, index) => (
            <div
              key={index}
              className={`option room-option ${
                watch("amenity.bathrooms") === option.id
                  ? "selected-option"
                  : EMPTY_STRING
              }`}
              onClick={() => {
                setValue("amenity.bathrooms", option.id);
                trigger("amenity.bathrooms");
              }}
            >
              {option.title}
            </div>
          ))}
        </div>
        {errors?.amenity?.bathrooms && (
          <div className="error mt-2">
            {errors?.amenity?.bathrooms?.message}
          </div>
        )}
      </div>
      <div className="instruction">
        *Our system validates the price. Please enter a realistic price for your
        property that is according to the market rates for the selected
        location.
      </div>
      <RoundedButton
        className="add-features-btn"
        onClick={handleOpenFeatureModal}
      >
        Add Features
      </RoundedButton>
    </div>
  );
};

export default FeaturesAndAmenities;
